declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { HCPService } from '../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../models/profileinfo/profileinfo.model';
import { ActorImageController, PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, SavePatientInfoRequest } from '../../../models/actor/actor';
//import { NgxMaskModule } from 'ngx-mask';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { CustomDateTimeService } from '../../../services/datetime.service';
//import './profilesteps.js';
//declare var mess1: any;
//declare var stepObject: any;
//declare var pSteps: any;
//declare var webGlObject: any;

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { PrintIDLService } from '../../../../../../src/app/ncs/services/printIDL.service';
import { NgbCustEditProfileModal } from '../profile/patientprofileview/personaldetailview/modal/custeditprofile.modal';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbPartnerDetails } from '../profile/patientprofileview/personaldetailview/modal/partnerdetails.modal';
import { NgbCameraUploadModal } from '../profile/patientprofileview/personaldetailview/modal/cameraupload.modal';


@Component({
  selector: 'custdashboard',
  templateUrl: './custdashboard.component.html',
  styleUrls: [
    './custdashboard.component.scss']
  ,
  animations: [routerTransition()]
})

export class CustDashboardComponent implements OnInit {

  @Input() ActorCode: number;
  @Input() ActorType: number;
  @Input() FormattedCode: string;
  @Input() CanEdit: number;
  @Input() CanShow: number;
  public UserName: string;
  public Password: string;

  public isRequesting: boolean = false;
  CurrentActorPersonalDetailInfoRequest: ActorPersonalDetailInfoRequest;
  CurrentActorPersonalDetailInfoController: ActorPersonalDetailInfoController;



  ValueChangeActorImageController: ActorImageController;

  public ApiResData: ApiResponseModel;

  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();

  DOB: NgbDateStruct;



  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  //
  public key: ActorPersonalDetailInfoController;

  @Input()
  get Key() {
    return this.key;
  }

  @Output() personalInfoChange = new EventEmitter();
  //set Key(value: ActorPersonalDetailInfoController) {
  //  this.key = value;
  //  //  alertFunctions.AlertParam(this.Key);
  //  console.log('personalInfoChange');
  //  this.personalInfoChange.emit(this.key);
  //}
  //

  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  CurrentSavePatientInfoRequest: SavePatientInfoRequest;
  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  SelectedPatient: PatientInfoByFormattedCodeController;
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.UserName;
    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    public printService: PrintService, public printServiceIDL: PrintIDLService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService, private actorservice: ActorService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) {
    //stepObject.init();
  }

  ngOnInit() {
    this.UserName = AppData.Instance().CustomerUserId;
    this.Password = AppData.Instance().CustomerPassword;
    this.SelectedFacilityCode = AppData.Instance().SelectedBranchCode;
    this.LoadPatients();
    this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);
    this.maxDate = { year: this.MaxDateV.getFullYear(), month: this.MaxDateV.getMonth() + 1, day: this.MaxDateV.getDate() };
    this.minDate = { year: 1900, month: 1, day: 1 };

    this.CanAdjustgetTimezoneOffset = AppData.CanAdjustgetTimezoneOffset;
    this.CurrentActorPersonalDetailInfoRequest = new ActorPersonalDetailInfoRequest();
    this.CurrentActorPersonalDetailInfoController = new ActorPersonalDetailInfoController();
    this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
    //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.ActorCode.toString();
    this.CurrentActorPersonalDetailInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSavePatientInfoRequest = new SavePatientInfoRequest();
    //this.CurrentActorEditGuardianInfoRequest.GuardianActorCode = this.ActorCode;
    this.CurrentSavePatientInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ValueChangeActorImageController = new ActorImageController();
    if (this.CanShow === 1) {
      this.GetActorPersonalDetailInfoController();
    }

  }

  onactorImageInfoChange(event: any) {


    if (event != null) {

      this.ValueChangeActorImageController = event;

      if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
        //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

        this.CurrentActorPersonalDetailInfoController.ActorImageFileUrl = this.ValueChangeActorImageController.ActorImageFileUrl;
      }


    }

  }
  onSubmit() {

    this.StartRefreshing();

    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  console.log('DateOfBirth----------' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
    //  this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.customdatetimeservice.converToLocalTime(this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
    //  console.log('DateOfBirth----------' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
    //}
    // console.log('this.DOB--->' + this.DOB);
    if (this.DOB != null) {



      this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DOB));;

      // console.log('this.DateOfBirth--->' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth );
    }
    this.hcpservice.SaveActorPersonalDetailInfo(this.CurrentActorPersonalDetailInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorPersonalDetailInfoController();

            // alertFunctions.AlertParam('Saved Successfully.....!');

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');



            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  EditDetails() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 20;
    this.CurrentSavePatientInfoRequest.ActorType = 3;
    this.CurrentSavePatientInfoRequest.DateOfBirth = this.SelectedPatient.DateOfBirth;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorCode = this.SelectedPatient.ActorCode;
    this.CurrentSavePatientInfoRequest.AddressLine1 = this.SelectedPatient.AddressLine1;
    this.CurrentSavePatientInfoRequest.Telephone1 = this.SelectedPatient.Telephone1;
    this.CurrentSavePatientInfoRequest.Prefix = this.SelectedPatient.Prefix;
    this.CurrentSavePatientInfoRequest.Gender = this.SelectedPatient.Gender;

    this.CurrentSavePatientInfoRequest.ReferalDetailCode = this.SelectedPatient.ReferalDetailCode;
    this.CurrentSavePatientInfoRequest.RefCode = this.SelectedPatient.RefCode;
    this.CurrentSavePatientInfoRequest.RefType = this.SelectedPatient.RefType;
    this.CurrentSavePatientInfoRequest.RefDetails = this.SelectedPatient.RefDetails;
    this.CurrentSavePatientInfoRequest.RefContactNo = this.SelectedPatient.RefContactNo1;
    this.CurrentSavePatientInfoRequest.RefInstitute = this.SelectedPatient.RefInstitute;
    this.CurrentSavePatientInfoRequest.RefContactNo2 = this.SelectedPatient.RefContactNo2;
    this.CurrentSavePatientInfoRequest.Remarks = this.SelectedPatient.Remarks;
    this.CurrentSavePatientInfoRequest.Religion = this.SelectedPatient.Religion;
    this.CurrentSavePatientInfoRequest.Institution = this.SelectedPatient.Institution;
    this.CurrentSavePatientInfoRequest.BloodGroup = this.SelectedPatient.BloodGroup;
    this.CurrentSavePatientInfoRequest.BirthIdentification1 = this.SelectedPatient.BirthIdentification1;
    this.CurrentSavePatientInfoRequest.Occupation = this.SelectedPatient.Occupation;
    this.CurrentSavePatientInfoRequest.Nationality = this.SelectedPatient.Nationality;
    this.CurrentSavePatientInfoRequest.EducationTitle = this.SelectedPatient.EducationTitle;
    this.CurrentSavePatientInfoRequest.EducationInDetail = this.SelectedPatient.EducationInDetail;
    this.CurrentSavePatientInfoRequest.IsInsured = this.SelectedPatient.IsInsured;
    this.CurrentSavePatientInfoRequest.InsuranceProvider = this.SelectedPatient.InsuranceProvider;
    this.CurrentSavePatientInfoRequest.MaritalStatus = this.SelectedPatient.MaritalStatus;
    this.CurrentSavePatientInfoRequest.Language = this.SelectedPatient.LanguagesKnown;
    this.CurrentSavePatientInfoRequest.OldRegistrationNo = this.SelectedPatient.OldRegistrationNumber;
    //this.CurrentSavePatientInfoRequest.Age = this.SelectedPatient.Age;
    this.CurrentSavePatientInfoRequest.RegistrationType = this.SelectedPatient.RegistrationType;
    this.CurrentSavePatientInfoRequest.RegistrationReason = this.SelectedPatient.RegistrationReason;
    this.CurrentSavePatientInfoRequest.BillingCategory = this.SelectedPatient.BillingCategory;
    this.CurrentSavePatientInfoRequest.RegistrationValidity = this.SelectedPatient.RegistrationValidity;
    this.CurrentSavePatientInfoRequest.PrimaryDoctor = this.SelectedPatient.PrimaryDoctor;
    this.CurrentSavePatientInfoRequest.City = this.SelectedPatient.City;
    this.CurrentSavePatientInfoRequest.State = this.SelectedPatient.State;
    this.CurrentSavePatientInfoRequest.County = this.SelectedPatient.County;
    this.CurrentSavePatientInfoRequest.ZipCode = this.SelectedPatient.ZipCode;
    this.CurrentSavePatientInfoRequest.Telephone2 = this.SelectedPatient.Telephone2;
    this.CurrentSavePatientInfoRequest.Email = this.SelectedPatient.Email;
    this.CurrentSavePatientInfoRequest.AddressLine2 = this.SelectedPatient.AddressLine2;
    this.CurrentSavePatientInfoRequest.IdProof = this.SelectedPatient.IdProof;
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.AddressCode = this.SelectedPatient.AddressCode;
    //this.CurrentSavePatientInfoRequest. = this.SelectedPatient.Age;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.DisplayName = this.SelectedPatient.DisplayName;
    const modalRef = this.modalService.open(NgbCustEditProfileModal,
      {
        centered: true,
        size: "lg",
        keyboard: false,
        backdrop: 'static'
      })
    modalRef.componentInstance.CurrentSavePatientInfoRequest = this.CurrentSavePatientInfoRequest;
    modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })
    //modalRef.componentInstance.ActorCode = this.ActorCode;

    //this.ViewDashboard = false;
    //this.ViewEditProfile = true;
    //this.CurrentSavePatientInfoRequest.ConditionalOperator = 20;
    //this.CurrentSavePatientInfoRequest.ActorType = 3;

  }
  //ngAfterViewInit() {
  //  //pSteps.loadStep();
  //}
  GetActorPersonalDetailInfoController() {

    this.StartRefreshing();
    this.hcpservice.GetActorPersonalDetailInfoController(this.CurrentActorPersonalDetailInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {


          this.CurrentActorPersonalDetailInfoController = this.ApiResData.Result[0];

          this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
          this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
          this.CurrentActorPersonalDetailInfoRequest.Salutation = this.CurrentActorPersonalDetailInfoController.Salutation;
          this.CurrentActorPersonalDetailInfoRequest.FirstName = this.CurrentActorPersonalDetailInfoController.FirstName;
          this.CurrentActorPersonalDetailInfoRequest.MiddleName = this.CurrentActorPersonalDetailInfoController.MiddleName;
          this.CurrentActorPersonalDetailInfoRequest.LastName = this.CurrentActorPersonalDetailInfoController.LastName;
          this.CurrentActorPersonalDetailInfoRequest.DisplayName = this.CurrentActorPersonalDetailInfoController.DisplayName;
          this.CurrentActorPersonalDetailInfoRequest.SocialSecurityNumber = this.CurrentActorPersonalDetailInfoController.SocialSecurityNumber;
          this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.CurrentActorPersonalDetailInfoController.DateOfBirth;



          if (this.CurrentActorPersonalDetailInfoController.DateOfBirth != null) {

            var SDOB = new Date(this.CurrentActorPersonalDetailInfoController.DateOfBirth);
            ;
            if (SDOB.getFullYear() > 1900) {

              this.DOB = {

                year: SDOB.getFullYear(),
                month: SDOB.getMonth() + 1,
                day: SDOB.getDate()
              }
            }
            else {
              this.DOB = {

                year: 1900,
                month: 1,
                day: 1
              }
            }
          }
          this.CurrentActorPersonalDetailInfoRequest.PlaceOfBirth = this.CurrentActorPersonalDetailInfoController.PlaceOfBirth;
          this.CurrentActorPersonalDetailInfoRequest.Gender = this.CurrentActorPersonalDetailInfoController.Gender;
          this.CurrentActorPersonalDetailInfoRequest.BloodGroup = this.CurrentActorPersonalDetailInfoController.BloodGroup;
          this.CurrentActorPersonalDetailInfoRequest.Nationality = this.CurrentActorPersonalDetailInfoController.Nationality;
          this.CurrentActorPersonalDetailInfoRequest.Religion = this.CurrentActorPersonalDetailInfoController.Religion;
          this.CurrentActorPersonalDetailInfoRequest.BirthIdentification1 = this.CurrentActorPersonalDetailInfoController.BirthIdentification1;
          this.CurrentActorPersonalDetailInfoRequest.BirthIdentification2 = this.CurrentActorPersonalDetailInfoController.BirthIdentification2;
          this.CurrentActorPersonalDetailInfoRequest.LiveIn = this.CurrentActorPersonalDetailInfoController.LiveIn;
          this.CurrentActorPersonalDetailInfoRequest.Occupation = this.CurrentActorPersonalDetailInfoController.Occupation;
          this.CurrentActorPersonalDetailInfoRequest.MaritalStatus = this.CurrentActorPersonalDetailInfoController.MaritalStatus;
          this.CurrentActorPersonalDetailInfoRequest.HasWorkPermit = this.CurrentActorPersonalDetailInfoController.HasWorkPermit;
          this.CurrentActorPersonalDetailInfoRequest.IsConvicted = this.CurrentActorPersonalDetailInfoController.IsConvicted;
          this.CurrentActorPersonalDetailInfoRequest.LanguagesSpoken = this.CurrentActorPersonalDetailInfoController.LanguagesSpoken;
          this.CurrentActorPersonalDetailInfoRequest.LanguagesRead = this.CurrentActorPersonalDetailInfoController.LanguagesRead;
          //
          //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
          //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
          this.CurrentActorPersonalDetailInfoRequest.AddressLine1 = this.CurrentActorPersonalDetailInfoController.AddressLine1;
          this.CurrentActorPersonalDetailInfoRequest.AddressLine2 = this.CurrentActorPersonalDetailInfoController.AddressLine2;
          this.CurrentActorPersonalDetailInfoRequest.City = this.CurrentActorPersonalDetailInfoController.City;
          this.CurrentActorPersonalDetailInfoRequest.State = this.CurrentActorPersonalDetailInfoController.State;
          this.CurrentActorPersonalDetailInfoRequest.Country = "AMERICA"
          //this.CurrentActorPersonalDetailInfoController.Country;
          this.CurrentActorPersonalDetailInfoRequest.Telephone1 = this.CurrentActorPersonalDetailInfoController.Telephone1;
          this.CurrentActorPersonalDetailInfoRequest.Telephone2 = this.CurrentActorPersonalDetailInfoController.Telephone2;
          this.CurrentActorPersonalDetailInfoRequest.Fax1 = this.CurrentActorPersonalDetailInfoController.Fax1;
          this.CurrentActorPersonalDetailInfoRequest.Fax2 = this.CurrentActorPersonalDetailInfoController.Fax2;
          this.CurrentActorPersonalDetailInfoRequest.Email = this.CurrentActorPersonalDetailInfoController.Email;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName = this.CurrentActorPersonalDetailInfoController.EmergencyContactPersonName;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo1;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo2 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo2;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyAddress = this.CurrentActorPersonalDetailInfoController.EmergencyAddress;
          this.CurrentActorPersonalDetailInfoRequest.Zip = this.CurrentActorPersonalDetailInfoController.Zip;
          //
          this.CurrentActorPersonalDetailInfoRequest.ProfileSummary = this.CurrentActorPersonalDetailInfoController.ProfileSummary;
          this.CurrentActorPersonalDetailInfoRequest.ProfileTitle = this.CurrentActorPersonalDetailInfoController.ProfileTitle;

          //this.key = this.ApiResData.Result[0];

          //this.personalInfoChange.emit(this.key);
          // console.log('this.personalInfoChange' + this.key.DisplayName);
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  OpenEditContent() {
    if (this.CanEdit === 1) {
      this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
      this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
      this.CurrentActorPersonalDetailInfoRequest.Salutation = this.CurrentActorPersonalDetailInfoController.Salutation;
      this.CurrentActorPersonalDetailInfoRequest.FirstName = this.CurrentActorPersonalDetailInfoController.FirstName;
      this.CurrentActorPersonalDetailInfoRequest.MiddleName = this.CurrentActorPersonalDetailInfoController.MiddleName;
      this.CurrentActorPersonalDetailInfoRequest.LastName = this.CurrentActorPersonalDetailInfoController.LastName;
      this.CurrentActorPersonalDetailInfoRequest.DisplayName = this.CurrentActorPersonalDetailInfoController.DisplayName;
      this.CurrentActorPersonalDetailInfoRequest.SocialSecurityNumber = this.CurrentActorPersonalDetailInfoController.SocialSecurityNumber;
      this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.CurrentActorPersonalDetailInfoController.DateOfBirth;
      this.CurrentActorPersonalDetailInfoRequest.PlaceOfBirth = this.CurrentActorPersonalDetailInfoController.PlaceOfBirth;
      this.CurrentActorPersonalDetailInfoRequest.Gender = this.CurrentActorPersonalDetailInfoController.Gender;
      this.CurrentActorPersonalDetailInfoRequest.BloodGroup = this.CurrentActorPersonalDetailInfoController.BloodGroup;
      this.CurrentActorPersonalDetailInfoRequest.Nationality = this.CurrentActorPersonalDetailInfoController.Nationality;
      this.CurrentActorPersonalDetailInfoRequest.Religion = this.CurrentActorPersonalDetailInfoController.Religion;
      this.CurrentActorPersonalDetailInfoRequest.BirthIdentification1 = this.CurrentActorPersonalDetailInfoController.BirthIdentification1;
      this.CurrentActorPersonalDetailInfoRequest.BirthIdentification2 = this.CurrentActorPersonalDetailInfoController.BirthIdentification2;
      this.CurrentActorPersonalDetailInfoRequest.LiveIn = this.CurrentActorPersonalDetailInfoController.LiveIn;
      this.CurrentActorPersonalDetailInfoRequest.Occupation = this.CurrentActorPersonalDetailInfoController.Occupation;
      this.CurrentActorPersonalDetailInfoRequest.MaritalStatus = this.CurrentActorPersonalDetailInfoController.MaritalStatus;
      this.CurrentActorPersonalDetailInfoRequest.HasWorkPermit = this.CurrentActorPersonalDetailInfoController.HasWorkPermit;
      this.CurrentActorPersonalDetailInfoRequest.IsConvicted = this.CurrentActorPersonalDetailInfoController.IsConvicted;
      this.CurrentActorPersonalDetailInfoRequest.LanguagesSpoken = this.CurrentActorPersonalDetailInfoController.LanguagesSpoken;
      this.CurrentActorPersonalDetailInfoRequest.LanguagesRead = this.CurrentActorPersonalDetailInfoController.LanguagesRead;
      //
      //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
      //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
      this.CurrentActorPersonalDetailInfoRequest.AddressLine1 = this.CurrentActorPersonalDetailInfoController.AddressLine1;
      this.CurrentActorPersonalDetailInfoRequest.AddressLine2 = this.CurrentActorPersonalDetailInfoController.AddressLine2;
      this.CurrentActorPersonalDetailInfoRequest.City = this.CurrentActorPersonalDetailInfoController.City;
      this.CurrentActorPersonalDetailInfoRequest.State = this.CurrentActorPersonalDetailInfoController.State;
      this.CurrentActorPersonalDetailInfoRequest.Country = "AMERICA";
      //this.CurrentActorPersonalDetailInfoController.Country;
      this.CurrentActorPersonalDetailInfoRequest.Telephone1 = this.CurrentActorPersonalDetailInfoController.Telephone1;
      this.CurrentActorPersonalDetailInfoRequest.Telephone2 = this.CurrentActorPersonalDetailInfoController.Telephone2;
      this.CurrentActorPersonalDetailInfoRequest.Fax1 = this.CurrentActorPersonalDetailInfoController.Fax1;
      this.CurrentActorPersonalDetailInfoRequest.Fax2 = this.CurrentActorPersonalDetailInfoController.Fax2;
      this.CurrentActorPersonalDetailInfoRequest.Email = this.CurrentActorPersonalDetailInfoController.Email;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName = this.CurrentActorPersonalDetailInfoController.EmergencyContactPersonName;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo1;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo2 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo2;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyAddress = this.CurrentActorPersonalDetailInfoController.EmergencyAddress;

      //
      this.CurrentActorPersonalDetailInfoRequest.ProfileSummary = this.CurrentActorPersonalDetailInfoController.ProfileSummary;
      this.CurrentActorPersonalDetailInfoRequest.ProfileTitle = this.CurrentActorPersonalDetailInfoController.ProfileTitle;

    }
    else {
      alertFunctions.AlertParam('Access Denied  Please Contact Admin....!');
    }

  }
  Partner() {

    const modalRef = this.modalService.open(NgbPartnerDetails,
      {
        centered: true,
        size: "lg",
        keyboard: false,
        backdrop: 'static'
      })
    modalRef.componentInstance.ActorCode = this.ActorCode;
  }
  ChangeImage() {
    const modalRef = this.modalService.open(NgbCameraUploadModal,
      {
        centered: true,


      })
    modalRef.componentInstance.ActorCode = this.ActorCode;
    modalRef.componentInstance.Photo = this.SelectedPatient.Photo;
  }

  //printcaserecord() {
  //  this.router.navigate(['print/caserecord']);
  //}
  printcaserecord() {
    this.printService.printDocument2(this.SelectedPatient.FormattedCode, 0

    );
    this.printService.printDocument("caserecord",
      {
        ActorCodeData: this.SelectedPatient.ActorCode, FaclityCodeData: this.SelectedPatient.FacilityCode,
      }
    );
  }
  //printcaserecordind() {
  //  this.router.navigate(['print/caserecordindividual', { FormattedCodeData: this.SelectedPatient.FormattedCode }]);
  //}
  printcaserecordind() {
    this.printService.printDocument2(this.SelectedPatient.FormattedCode, 0

    );
    this.printService.printDocument("caserecordindividual",
      {
        FormattedCodeData: this.SelectedPatient.FormattedCode, FaclityCodeData: this.SelectedPatient.FacilityCode,
      }
    );
  }
  printidl() {
    this.printService.printDocument("IDL",
      {
        FormattedCodeData: this.SelectedPatient.FormattedCode, FaclityCodeData: this.SelectedPatient.FacilityCode,
      }
    );
  }
  SelectedFacilityCode: number;
  SelectedFacilityName: string;

  Roleassign(event: any) {

    if (event != null) {


      this.SelectedFacilityName = event;
      //this.LoadDoctorsList(this.SelectedFacilityCode);
    }

  }
}
